import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router';
import ReactGA from 'react-ga4';

import { GuestApp } from 'src/auth/guest/guest-app';
import { ErrorBoundary } from 'src/routes/components';

// ----------------------------------------------------------------------

const router = createBrowserRouter([
  {
    path: '*',
    Component: GuestApp,
    errorElement: <ErrorBoundary />,
  },
]);

// @ts-ignore
const gaMeasurementId: string | undefined = GA_MEASUREMENT_ID;
if (gaMeasurementId) {
  ReactGA.initialize(gaMeasurementId);
} else {
  console.warn('GA_MEASUREMENT_ID is not configured; analytics is off');
}

const container = document.getElementById('root');
if (!container) {
  throw new Error('Missing #root element');
}

createRoot(container).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);
